// With apologies to other Chromium-based browsers that actually GIVE DEVELOPERS WHAT THEY WANT!
const iAmABrowserDevelopedBySimiansPerchedOnAnIvoryTowerWithNoGraspOfReality =
	typeof window != 'undefined' && typeof (window as any).chrome != 'undefined' && !(window.navigator as any).brave;

export const DISABLE_BROWSER_AUTOFILL_SETTINGS = {
	/*
    As of Sept 2020 (https://stackoverflow.com/questions/15738259/disabling-chrome-autofill):
	Update May 2023: Edge/Chrome respects autocomplete=chrome-off, Brave respects autocomplete=off

    Until the next forced browser update breaks this once more ...
    */
	autoComplete: 'off'
};
